import { render, staticRenderFns } from "./AcceptUserAuthInvitation.vue?vue&type=template&id=2da97aba&"
import script from "./AcceptUserAuthInvitation.vue?vue&type=script&lang=js&"
export * from "./AcceptUserAuthInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports